<template>
  <Loading v-show="show" />

  <div id="nav">
    <header>
      <div class="header-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 d-none d-lg-block d-md-block">
             
              <p style="    margin-bottom: 0rem;"> 
              <span style="    margin-left: 10px;" id="address_header"></span>
              <span style="    margin-left: 10px;" id="phone_header"></span>
              </p>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="header-top-right">
                <div class="content">
                  <router-link to="/ContactUs" id="welcom_header" > </router-link>
                </div>
                <div class="content lang_div_med">
                  <a id="lang_btn" @click="lang('Ar')">العربية</a>
                </div>
                <div class="content lang_div_med">
                  <a id="lang_btn" @click="lang('En')">English</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-logo-menu sticker">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-12">
              <div class="logo">
                <router-link to="/">
                  <img
                    id="logo_image_newTouch"
                    v-bind:src="TopLogoUrl"
                    alt=""
                  />
                </router-link>
              </div>
            </div>
            <div class="col-lg-9 col-12">
              <div class="mainmenu-area pull-left" style="text-align: left">
                <div class="mainmenu d-none d-lg-block">
                  <nav>
                    <ul id="nav">
                      <li class="current">
                        <router-link to="/">{{ home }}</router-link>
                      </li>
                      <li>
                        <a href="javascript:void(0)">{{ aboutUs }} </a>
                        <ul class="sub-menu" style="width: 280px">
                          <li v-for="leader in Leader" :key="leader.postId">
                            <router-link
                              :to="{
                                name: 'Leader-with-id-And-Type',
                                params: {
                                  type: 'Univ.Home.Leader',
                                  id: leader.postID,
                                },
                              }"
                            >
                              {{ leader.postTitle }}<i :class="leader.icon1"></i
                            ></router-link>
                          </li>
                          <li
                            v-for="aboutdata in AboutData"
                            :key="aboutdata.postId"
                          >
                            <router-link
                              :to="{
                                name: 'Page-with-id-And-Type',
                                params: {
                                  type: 'Univ.Home.AboutMenue',
                                  id: aboutdata.postID,
                                },
                              }"
                            >
                              {{ aboutdata.postTitle
                              }}<i :class="aboutdata.icon1"></i
                            ></router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- for management -->
                      <li>
                        <a href="javascript:void(0)">{{ Management }} </a>
                        <ul class="sub-menu" style="width: 280px">
                          <li
                            v-for="managedata in ManagementData"
                            :key="managedata.postId"
                          >
                            <router-link
                              :to="{
                                name: 'Page-with-id-And-Type',
                                params: {
                                  type: 'Univ.Managments',
                                  id: managedata.postID,
                                },
                              }"
                            >
                              {{ managedata.postTitle
                              }}<i :class="managedata.icon1"></i
                            ></router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- end management   -->
                      <li>
                        <a href="javascript:void(0)">{{ colege }}</a>
                        <ul class="sub-menu" style="width: 288px">
                          <li v-for="faculty in Faculty" :key="faculty.BrnId">
                            <router-link
                              :to="{
                                name: 'Faculties-with-id',
                                params: {
                                  id: faculty.BrnId,
                                },
                              }"
                            >
                              {{ faculty.Faculty }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="javascript:void(0)">البحث العلمي</a>
                        <ul class="sub-menu" style="width: 288px">
                          <li
                            v-for="research in Research"
                            :key="research.BrnId"
                          >
                            <router-link
                              :to="{
                                name: 'research-with-id',
                                params: {
                                  id: research.BrnId,
                                },
                              }"
                            >
                              {{ research.Faculty }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="javascript:void(0)">{{ cnter }}</a>

                        <ul class="sub-menu" style="width: 280px">
                          <li
                            v-for="centerdata in CenterData"
                            :key="centerdata.postId"
                          >
                            <router-link
                              :to="{
                                name: 'Page-with-id-And-Type',
                                params: {
                                  type: 'Univ.Q.Center',
                                  id: centerdata.postID,
                                },
                              }"
                            >
                              {{ centerdata.postTitle
                              }}<i :class="centerdata.icon1"></i
                            ></router-link>
                          </li>
                        </ul>
                      </li>

                      <!-- service -->
                      <li>
                        <a href="javascript:void(0)">{{ Service }} </a>
                        <ul class="sub-menu" style="width: 288px">
                          <li
                            v-for="service in ServiceData"
                            :key="service.postID"
                          >
                            <router-link
                              :to="{
                                name: 'Service',
                                params: {
                                  id: service.postID,
                                },
                              }"
                            >
                              {{ service.postTitle }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- end service -->

                      <li class="current">
                        <a href="https://g.oasyemen.net/portal/" target="_blank">{{ portal }} </a>
                      </li>

                      <!-- <li style="margin-left: 24px">
                        <router-link to="/ContactUs"
                          >{{ contact2 }}
                        </router-link>
                      </li> -->
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Menu Area start -->
      <div class="mobile-menu-area">
        <div class="container clearfix">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="mobile-menu">
                <nav id="dropdown">
                  <ul dir="rtl">
                    <li class="current">
                      <router-link to="/">{{ home }}</router-link>
                    </li>

                    <li>
                      <a href="javascript:void(0)">{{ aboutUs }} </a>
                      <ul class="sub-menu" style="width: 280px">
                        <li v-for="leader in Leader" :key="leader.postId">
                          <router-link
                            :to="{
                              name: 'Leader-with-id-And-Type',
                              params: {
                                type: 'Univ.Home.Leader',
                                id: leader.postID,
                              },
                            }"
                          >
                            {{ leader.postTitle }}<i :class="leader.icon1"></i
                          ></router-link>
                        </li>

                        <li
                          v-for="aboutdata in AboutData"
                          :key="aboutdata.postId"
                        >
                          <router-link
                            :to="{
                              name: 'Page-with-id-And-Type',
                              params: {
                                type: 'Univ.Home.AboutMenue',
                                id: aboutdata.postID,
                              },
                            }"
                          >
                            {{ aboutdata.postTitle
                            }}<i :class="aboutdata.icon1"></i
                          ></router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- fore management  -->
                    <li>
                      <a href="javascript:void(0)">{{ Management }} </a>
                      <ul class="sub-menu" style="width: 280px">
                        <li
                          v-for="managedata in ManagementData"
                          :key="managedata.postId"
                        >
                          <router-link
                            :to="{
                              name: 'Page-with-id-And-Type',
                              params: {
                                type: 'Univ.Managments',
                                id: managedata.postID,
                              },
                            }"
                          >
                            {{ managedata.postTitle
                            }}<i :class="managedata.icon1"></i
                          ></router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- end management -->
                    <li>
                      <a href="javascript:void(0)">{{ colege }}</a>
                      <ul class="sub-menu">
                        <li v-for="faculty in Faculty" :key="faculty.BrnId">
                          <router-link
                            :to="{
                              name: 'Faculties-with-id',
                              params: {
                                id: faculty.BrnId,
                              },
                            }"
                          >
                            {{ faculty.Faculty }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="javascript:void(0)">البحث العلمي</a>
                      <ul class="sub-menu" style="width: 288px">
                        <li v-for="research in Research" :key="research.BrnId">
                          <router-link
                            :to="{
                              name: 'research-with-id',
                              params: {
                                id: research.BrnId,
                              },
                            }"
                          >
                            {{ research.Faculty }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="javascript:void(0)">{{ cnter }}</a>

                      <ul class="sub-menu">
                        <li
                          v-for="centerdata in CenterData"
                          :key="centerdata.postId"
                        >
                          <router-link
                            :to="{
                              name: 'Page-with-id-And-Type',
                              params: {
                                type: 'Univ.Q.Center',
                                id: centerdata.postID,
                              },
                            }"
                          >
                            {{ centerdata.postTitle }}
                            ></router-link
                          >
                        </li>
                      </ul>
                    </li>
                    <!-- service -->
                    <li>
                      <a href="javascript:void(0)">{{ Service }} </a>
                      <ul class="sub-menu" style="width: 288px">
                        <li
                          v-for="service in ServiceData"
                          :key="service.postID"
                        >
                          <router-link
                            :to="{
                              name: 'Service',
                              params: {
                                id: service.postID,
                              },
                            }"
                          >
                            {{ service.postTitle }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- end service -->
                    <!-- <li class="current">
                      <router-link to="/ComingSoon"> {{ portal }}</router-link>
                    </li> -->

                    <li>
                      <router-link to="/ContactUs"> {{ contact2 }}</router-link>
                      <ul class="sub-menu">
                        <li>
                          <router-link to="/ContactUs"
                            >الموقع الجغرافى</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/ContactUs"
                            >ارقام التواصل</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/ContactUs">
                            ارسال رسالة</router-link
                          >
                        </li>
                      </ul>
                    </li>

                    <li>
                      <a href="javascript:void(0)"> {{ language }}</a>
                      <ul class="sub-menu">
                        <a href="javascript:void(0)">
                          <li @click="lang('Ar')">العربية</li></a
                        >
                        <a href="javascript:void(0)">
                          <li @click="lang('En')">English</li></a
                        >
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <router-view :key="$route.fullPath"></router-view>
    
    <div class="newsletter-area  newsletter-area_3 " style="   border-radius: 0 !important;background: rgba(0, 0, 0, 0) url(img/banner/2.jpg) repeat scroll 100% 0;">
      <div class="container">
        <div class="row rowFooter">
          <div class="col-lg-5 col-md-5">
            <div class="newsletter-content">
              <h3 id="postTitleFooter"></h3>
              <h2 id="postSubTitleFooter"></h2>
            </div>
          </div>
          <div class="col-lg-7 col-md-7">
            <div class="newsletter-form angle d-none">
              <form
                action="#"
                id="mc-form"
                class="mc-form footer-newsletter fix"
              >
                <div class="subscribe-form">
                  <input
                    id="mc-email "
                    type="email "
                    name="email "
                    placeholder="ادخل البريد الالكترونى"
                  />
                  <button id="mc-submit " type="submit">الإشتراك</button>
                </div>
              </form>
              <div class="mailchimp-alerts text-centre fix pull-left">
                <div class="mailchimp-submitting"></div>
                <div class="mailchimp-success"></div>
                <div class="mailchimp-error"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-widget-area" style="    background: rgba(0, 0, 0, 0) url(img/banner/2.jpg) repeat scroll 100% 0;">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="single-footer-widget">
              <div class="footer-logo">
                <router-link to="/">
                  <img v-bind:src="bottomLogoUrl" alt=" "
                /></router-link>
              </div>
              <p id="postDetails"></p>
              <div class="social-icons">
                <a id="facebook_footer" target="_blank"
                  ><img src="/img/facebook.svg" alt="" />
                </a>
                <a id="instgram_footer" target="_blank"
                  ><img src="/img/instagram.svg" alt=""
                /></a>
                <a id="twitter_footer" target="_blank"
                  ><img src="/img/twitter.svg" alt=""
                /></a>
                <a id="youtube_footer" target="_blank"
                  ><img src="/img/youtube.svg" alt=""
                /></a>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-footer-widget">
              <h3>{{ contct }}</h3>
              <!-- <a id="f11_footer" href="tel:0123-456-789 "></a> -->
              <a href="tel:0123-456-789 " id="f21_footer"></a>
              <a href="tel:0123-456-789 " id="f31_footer"></a>
              <span id="f41_footer"></span>
              <span id="f51_footer"></span>
              <span id="f61_footer"></span>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-footer-widget">
              <h3>{{ browseMore }}</h3>
              <ul class="footer-list">
                <li>
                  <router-link to="/">{{ home }}</router-link>
                </li>

                <li v-for="leader in Leader" :key="leader.postId">
                  <router-link
                    :to="{
                      name: 'Leader-with-id-And-Type',
                      params: {
                        type: 'Univ.Home.Leader',
                        id: leader.postID,
                      },
                    }"
                  >
                    {{ leader.postTitle }}</router-link
                  >
                </li>

                <li v-for="aboutdata in AboutData" :key="aboutdata.postId">
                  <router-link
                    :to="{
                      name: 'Page-with-id-And-Type',
                      params: {
                        type: 'Univ.Home.AboutMenue',
                        id: aboutdata.postID,
                      },
                    }"
                  >
                    {{ aboutdata.postTitle }}</router-link
                  >
                </li>
                
                  <li style="margin-left: 24px">
                        <router-link to="/ContactUs"
                          >{{ contact2 }}
                        </router-link>
                      </li> 
              </ul>
            </div>
          </div>
           <div class="col-lg-3 col-md-6">
            <div class="single-footer-widget">
              <h3> {{colege}} </h3>
              <ul class="footer-list">
                <li v-for="faculty in Faculty" :key="faculty.BrnId">
                            <router-link
                              :to="{
                                name: 'Faculties-with-id',
                                params: {
                                  id: faculty.BrnId,
                                },
                              }"
                            >
                              {{ faculty.Faculty }}
                            </router-link>
                          </li>

        
                
                  <li style="margin-left: 24px">
                        <router-link to="/ContactUs"
                          >{{ contact2 }}
                        </router-link>
                      </li> 
              </ul>
            </div>
          </div>
    
        </div>
      </div>
    </div>
    <footer class="footer-area " style=" border-radius: 0 !important">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-7 col-12">
            <span>{{ copyRight }}</span>
          </div>
          <div class="col-lg-6 col-md-5 col-12">
            <div class="column-right">
              <span
                >Powered by<a
                  class="link_newtouch"
                  href="http://newtouch.dev/"
                  target="_blank"
                >
                  NewTouch</a
                >
                Smart Technology Solutions
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Loading from "./components/Loading";
import axios from "axios";
import ArJson from "../public/i18n/Ar.json";
import EnJson from "../public/i18n/En.json";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      show: true,
      TopLogoUrl: "",
      bottomLogoUrl: "",
      FooterData: [],
      AboutData: [],
      Leader: [],
      CenterData: [],
      Gellery: [],
      Faculty: [],
      Research: [],
      ArTranslat: ArJson,
      EnTranslat: EnJson,
      translate: "",
      home: "",
      aboutUs: "",
      cnter: "",
      colege: "",
      portal: "",
      contct: "",
      language: "",
      browseMore: "",
      copyRight: "",

      Management: "",
      Service: "",
      contact2: "",
      ServiceData: [],
      ManagementData: [],
    };
  },
  mounted() {
    var self = this;
    if (localStorage.getItem("lang") == null) {
      axios({
        method: "get",
        url: "https://api2.yuniv.net:444/languages/getLangIsMain",
      })
        .then(function (response) {
          self.lang = response.data[0]["LangId"];
          localStorage.setItem("lang", response.data[0]["LangId"]);
          if (response.data[0]["LangId"] == "Ar") {
            self.translate = self.ArTranslat;
            document.getElementById("langfilewebsites")?.remove();
            self.getApis();
          } else {
            self.translate = self.EnTranslat;
            let link1 = document.createElement("link");
            link1.setAttribute("rel", "stylesheet");
            link1.id = "langfilewebsites";
            link1.setAttribute("href", "./style-ltr.css");
            document.head.appendChild(link1);
            self.getApis();
          }
        })
        .catch(function (response) {
          console.log("error", response);
        });
    } else {
      //translate
      if (localStorage.getItem("lang") == "Ar") {
        self.translate = self.ArTranslat;
        document.getElementById("langfilewebsites")?.remove();
        self.getApis();
      } else {
        self.translate = self.EnTranslat;
        let link1 = document.createElement("link");
        link1.setAttribute("rel", "stylesheet");
        link1.id = "langfilewebsites";
        link1.setAttribute("href", "./style-ltr.css");
        document.head.appendChild(link1);
        self.getApis();
      }
    }
  },
  methods: {
    lang(lang) {
      localStorage.setItem("lang", lang);
      location.reload();
    },
    getApis() {
      var self = this;
      var bodyFormData2 = new FormData();
      self.home = self.translate[0]["HeaderAndFooter"]["Home"];
      self.aboutUs = self.translate[0]["HeaderAndFooter"]["about"];
      self.colege = self.translate[0]["HeaderAndFooter"]["college"];
      self.cnter = self.translate[0]["HeaderAndFooter"]["centers"];
      self.portal = self.translate[0]["HeaderAndFooter"]["studentPortal"];
      self.contct = self.translate[0]["HeaderAndFooter"]["contact"];
      self.language = self.translate[0]["HeaderAndFooter"]["Languages"];
      self.browseMore = self.translate[0]["HeaderAndFooter"]["browseMore"];
      self.copyRight = self.translate[0]["HeaderAndFooter"]["copyRight"];
      self.contact2 = self.translate[0]["HeaderAndFooter"]["contact2"];
      self.Service = self.translate[0]["HeaderAndFooter"]["Service"];
      self.Management = self.translate[0]["HeaderAndFooter"]["Management"];
      // self.library = self.ArTranslat[0]["HeaderAndFooter"]["library"];

      bodyFormData2.append("check", "getPost");
      bodyFormData2.append("Lang", localStorage.getItem("lang"));
      bodyFormData2.append("FbrnId", "");
      bodyFormData2.append("Type", "Univ.Header.Data");
      bodyFormData2.append("ParentId", "NTROOT0");
      bodyFormData2.append("PostName", "");
      bodyFormData2.append("Pno", "1");
      axios({
        method: "post",
        url: "https://api2.yuniv.net:444/our_team/getPost",
        data: bodyFormData2,
      })
        .then(function (response) {
          var arr = response.data;
          if (arr.length != 0) {
            self.TopLogoUrl =
              "https://api2.yuniv.net:444/images/post/" +
              response.data[0]["postImage"];
            document.getElementById("welcom_header").innerHTML =
              '<i class="fa fa-graduation-cap"style="padding-left: 7px; font-size: 16px"></i>' +
              response.data[0]["f1"];
            document.getElementById("address_header").innerHTML =
              '<i class="fa  fa-map-marker"></i>' + response.data[0]["f2"];
            document.getElementById("phone_header").innerHTML =
              '<i class="fa fa-phone"></i>' + response.data[0]["f3"];
          }
          var bodyFormData = new FormData();
          bodyFormData.append("check", "getPostDetails");
          bodyFormData.append("Lang", localStorage.getItem("lang"));
          bodyFormData.append("FbrnId", "");
          bodyFormData.append("Type", "Univ.Footer.Data");
          bodyFormData.append("ParentId", "NTROOT0");
          bodyFormData.append("PostName", "");
          bodyFormData.append("Pno", "1");
          axios({
            method: "post",
            url: "https://api2.yuniv.net:444/our_team/getPost",
            data: bodyFormData,
          })
            .then(function (response) {
              self.FooterData = response.data;
              if (self.FooterData.length != 0) {
                self.bottomLogoUrl =
                  "https://api2.yuniv.net:444/images/post/" +
                  self.FooterData[0]["postImage"];

                document
                  .getElementById("facebook_footer")
                  .setAttribute("href", response.data[0]["facebook1"]);

                document
                  .getElementById("facebook_footer")
                  .setAttribute("href", response.data[0]["facebook1"]);
                document
                  .getElementById("instgram_footer")
                  .setAttribute("href", response.data[0]["instgram1"]);
                document
                  .getElementById("twitter_footer")
                  .setAttribute("href", response.data[0]["tweeter1"]);
                document
                  .getElementById("youtube_footer")
                  .setAttribute("href", response.data[0]["youtube1"]);

                document.getElementById("postTitleFooter").innerText =
                  response.data[0]["postTitle"];
                document.getElementById("postSubTitleFooter").innerText =
                  response.data[0]["postSubTitle"];
                // document.getElementById("f11_footer").innerHTML =
                //   '<i class="fa fa-phone"></i>' + response.data[0]["f11"];
                document.getElementById("f21_footer").innerHTML =
                  '<i class="fa fa-phone"></i>' + response.data[0]["f21"];
                document.getElementById("f31_footer").innerHTML =
                  '<i class="fa fa-phone"></i>' + response.data[0]["f31"];
                document.getElementById("f41_footer").innerHTML =
                  '<i class="fa fa-envelope"></i>' + response.data[0]["f41"];
                document.getElementById("f51_footer").innerHTML =
                  '<i class="fa fa-globe"></i>' + response.data[0]["f51"];
                document.getElementById("f61_footer").innerHTML =
                  '<i class="fa fa-map-marker"></i>' + response.data[0]["f61"];

                document.getElementById("postDetails").innerHTML =
                  self.FooterData[0]["postDetails"];
              }
              var bodyFormData = new FormData();
              bodyFormData.append("check", "getPost");
              bodyFormData.append("Lang", localStorage.getItem("lang"));
              bodyFormData.append("FbrnId", "");
              bodyFormData.append("Type", "Univ.Home.AboutMenue");
              bodyFormData.append("ParentId", "NTROOT0");
              bodyFormData.append("PostName", "");
              bodyFormData.append("Pno", "5");
              axios({
                method: "post",
                url: "https://api2.yuniv.net:444/our_team/getPost",
                data: bodyFormData,
              })
                .then(function (response) {
                  self.AboutData = response.data;

                  var bodyFormData = new FormData();
                  bodyFormData.append("check", "getPost");
                  bodyFormData.append("Lang", localStorage.getItem("lang"));
                  bodyFormData.append("FbrnId", "");
                  bodyFormData.append("Type", "Univ.Home.Leader");
                  bodyFormData.append("ParentId", "NTROOT0");
                  bodyFormData.append("PostName", "");
                  bodyFormData.append("Pno", "6");
                  axios({
                    method: "post",
                    url: "https://api2.yuniv.net:444/our_team/getPost",
                    data: bodyFormData,
                  })
                    .then(function (response) {
                      self.Leader = response.data;

                      var bodyFormData = new FormData();
                      bodyFormData.append("check", "getPost");
                      bodyFormData.append("Lang", localStorage.getItem("lang"));
                      bodyFormData.append("FbrnId", "");
                      bodyFormData.append("Type", "Univ.Q.Center");
                      bodyFormData.append("ParentId", "NTROOT0");
                      bodyFormData.append("PostName", "");
                      bodyFormData.append("Pno", "10");
                      axios({
                        method: "post",
                        url: "https://api2.yuniv.net:444/our_team/getPost",
                        data: bodyFormData,
                      })
                        .then(function (response) {
                          self.CenterData = response.data;
                          // service
                          var bodyFormData = new FormData();
                          bodyFormData.append("check", "getPost");
                          bodyFormData.append(
                            "Lang",
                            localStorage.getItem("lang")
                          );
                          bodyFormData.append("FbrnId", "");
                          bodyFormData.append("Type", "Univ.Services"); //لازم يتغير النوع لانه خاطئ
                          bodyFormData.append("ParentId", "NTROOT0");
                          bodyFormData.append("PostName", "");
                          bodyFormData.append("Pno", "10");
                          axios({
                            method: "post",
                            url: "https://api2.yuniv.net:444/our_team/getPost",
                            data: bodyFormData,
                          })
                            .then(function (response) {
                              self.ServiceData = response.data;
                              //end service

                              // management
                              var bodyFormData = new FormData();
                              bodyFormData.append("check", "getPost");
                              bodyFormData.append(
                                "Lang",
                                localStorage.getItem("lang")
                              );
                              bodyFormData.append("FbrnId", "");
                              bodyFormData.append("Type", "Univ.Managments");
                              bodyFormData.append("ParentId", "NTROOT0");
                              bodyFormData.append("PostName", "");
                              bodyFormData.append("Pno", "10");
                              axios({
                                method: "post",
                                url:
                                  "https://api2.yuniv.net:444/our_team/getPost",
                                data: bodyFormData,
                              })
                                .then(function (response) {
                                  self.ManagementData = response.data;
                                  //end management
                                  var bodyFormData = new FormData();
                                  bodyFormData.append("check", "getPost");
                                  bodyFormData.append(
                                    "Lang",
                                    localStorage.getItem("lang")
                                  );
                                  bodyFormData.append("FbrnId", "");
                                  bodyFormData.append("Type", "Univ.Gellery");
                                  bodyFormData.append("ParentId", "NTROOT0");
                                  bodyFormData.append("PostName", "");
                                  bodyFormData.append("Pno", "6");
                                  axios({
                                    method: "post",
                                    url:
                                      "https://api2.yuniv.net:444/our_team/getPost",
                                    data: bodyFormData,
                                  })
                                    .then(function (response) {
                                      self.Gellery = response.data;

                                      bodyFormData = new FormData();
                                      bodyFormData.append("check", "");
                                      bodyFormData.append(
                                        "Lang",
                                        localStorage.getItem("lang")
                                      );
                                      bodyFormData.append("FbrnId", "U");
                                      axios({
                                        method: "post",
                                        url:
                                          "https://api2.yuniv.net:444/our_team/getMainSys",
                                        data: bodyFormData,
                                      })
                                        .then(function (response) {
                                          response.data.mainBrn.forEach(
                                            (element) => {
                                              if (
                                                element.brnSys == "Univ.Faculty"
                                              )
                                                self.Faculty.push({
                                                  BrnId: element.brnId,
                                                  Faculty: element.brnName,
                                                });
                                            }
                                          );
                                          bodyFormData.append("FbrnId", "U");
                                          axios({
                                            method: "post",
                                            url:
                                              "https://api2.yuniv.net:444/our_team/getMainSys",
                                            data: bodyFormData,
                                          })
                                            .then(function (response) {
                                              response.data.mainBrn.forEach(
                                                (element) => {
                                                  if (
                                                    element.brnSys ==
                                                    "Univ.Research"
                                                  )
                                                    self.Research.push({
                                                      BrnId: element.brnId,
                                                      Faculty: element.brnName,
                                                    });
                                                }
                                              );

                                              setTimeout(() => {
                                                self.show = false;
                                              }, 100);
                                            })
                                            .catch(function (response) {
                                              console.log("error", response);
                                            });
                                        })
                                        .catch(function (response) {
                                          console.log("error", response);
                                        });
                                    })
                                    .catch(function (response) {
                                      console.log("error", response);
                                    });
                                })
                                .catch(function (response) {
                                  console.log("error", response);
                                });
                            })
                            .catch(function (response) {
                              console.log("error", response);
                            });
                        })
                        .catch(function (response) {
                          console.log("error", response);
                        });
                    })
                    .catch(function (response) {
                      console.log("error", response);
                    });
                })
                .catch(function (response) {
                  console.log("error", response);
                });
            })
            .catch(function (response) {
              console.log("error", response);
            });
        })
        .catch(function (response) {
          console.log("error", response);
        });
    },
  },
};
</script>
<style scoped>
.newsletter-area_3::before{
      border-radius: 40px 0px 0px 40px !important;
}
.lang_btn {
  cursor: pointer !important;
}
.font_color {
  color: #0c3ef7;
}
.link_newtouch {
  color: #0c3ef7;
  font-weight: bold;
}
li i {
  color: #0c3ef7;
}
li a {
  font-weight: bold;
}
.footer-img {
  width: 80px;
  height: 80px;
}
.mean-container .mean-nav ul li a {
  background: #f8f8f8;
  color: #666;
  display: block;
  float: left;
  font-size: 12px;
  margin: 0;
  padding: 1em 5%;
  text-align: right;
  text-decoration: none;
  text-transform: uppercase;
  width: 90%;
  font-weight: 700;
}
.mean-container .mean-nav ul li a.mean-expand {
  width: 26px;
  height: 15px;
  margin-top: 1px;
  padding: 12px !important;
  text-align: center;
  position: absolute;
  left: 0 !important;
  top: 0;
  z-index: 2;
  font-weight: 700;
  border: 0 !important;
  background: #f8f8f8;
}
#postTitleFooter,
#postSubTitleFooter {
  color: #000;
}
#logo_image_newTouch {
  margin-top: -7px;
}
</style>
